// react-bootstrap imports
import Col from "react-bootstrap/Col"
import Row from "react-bootstrap/Row"
import Stack from "react-bootstrap/Stack"
import Container from "react-bootstrap/Container"

import { Link } from "react-router-dom"

// assets imports
import headerHome from "assets/header_home.png"
import headerAcessColors from "assets/header_acess_colors.png"
import logoPrefeitura from "assets/logo_prefeitura.png"

function Image({ src, onClick })
{
    return (<img src={src} onClick={onClick} className="mx-1" width="20px" height="20px" alt="ícone"/>)
}

function SwitchColors()
{

    var r = document.querySelector(':root')
    var rs = getComputedStyle(r)
    if (rs.getPropertyValue('--bs-primary') === '#fff')  // switch back to default color style
    {
        r.style.setProperty('--bs-primary', '#0d6efd')
        r.style.setProperty('--btn-color', '#fff')
        r.style.setProperty('--bs-light-rgb', 'rgb(248,249,250)')
    }
    else    // switch to acessible color style
    {
        const buttons = document.getElementsByTagName("button")
        for (let i = 0; i <= buttons.length - 1; i += 1)
        {
            buttons[i].classList.toggle('btn-primary')
            buttons[i].classList.toggle('btn-dark')
        }

        const links = document.getElementsByTagName("a")
        for (let i = 0; i <= links.length - 1; i += 1)
        {
            links[i].classList.toggle('btn-primary')
            links[i].classList.toggle('btn-dark')
        }

        const elementsBgLight = document.getElementsByClassName("bg-light")
        for (let i = 0; i <= elementsBgLight.length - 1; i += 1)
        {
            elementsBgLight[i].classList.toggle('bg-white')
        }

        //r.style.setProperty('--bs-primary', '#fff')
        //r.style.setProperty('--btn-color', '#000')
        //r.style.setProperty('--bs-light-rgb', 'black')
    }
    
}

function ShortenFont()
{
    var r = document.querySelector(':root')
    var rs = getComputedStyle(r)
    if (rs.getPropertyValue('--tx-fs1') === 'calc(1.375rem + 1.5vw)')
    {
        r.style.setProperty('--tx-fs1', 'calc(1.325rem + 0.9vw)')
        r.style.setProperty('--tx-fs2', 'calc(1.3rem + 0.6vw)')
        r.style.setProperty('--tx-fs3', 'calc(1.275rem + 0.3vw)')
        r.style.setProperty('--tx-fs4', '1.25rem')
        r.style.setProperty('--tx-fs5', '1rem')
        r.style.setProperty('--tx-fs6', '0.8rem')
        r.style.setProperty('--tx-fs7', '0.6rem')
    }
}

function DefaultFont()
{
    var r = document.querySelector(':root')
    // var rs = getComputedStyle(r)
    r.style.setProperty('--tx-fs1', 'calc(1.375rem + 1.5vw)')
    r.style.setProperty('--tx-fs2', 'calc(1.325rem + 0.9vw)')
    r.style.setProperty('--tx-fs3', 'calc(1.3rem + 0.6vw)')
    r.style.setProperty('--tx-fs4', 'calc(1.275rem + 0.3vw)')
    r.style.setProperty('--tx-fs5', '1.25rem')
    r.style.setProperty('--tx-fs6', '1rem')
    r.style.setProperty('--tx-fs7', '0.8rem')
}

function EnlargeFont()
{
    var r = document.querySelector(':root')
    var rs = getComputedStyle(r)
    if (rs.getPropertyValue('--tx-fs1') === 'calc(1.375rem + 1.5vw)')
    {
        r.style.setProperty('--tx-fs1', 'calc(1.4rem + 2.0vw)')
        r.style.setProperty('--tx-fs2', 'calc(1.375rem + 1.5vw)')
        r.style.setProperty('--tx-fs3', 'calc(1.325rem + 0.9vw)')
        r.style.setProperty('--tx-fs4', 'calc(1.3rem + 0.6vw)')
        r.style.setProperty('--tx-fs5', 'calc(1.275rem + 0.3vw)')
        r.style.setProperty('--tx-fs6', '1.25rem')
        r.style.setProperty('--tx-fs7', '1rem')
    }
}

function PrefeituraInfo()
{
    return(
        <Stack direction="horizontal">
            <img src={logoPrefeitura} width="20%" height="20%" alt="logo" />
            <p className="fw-bold">PREFEITURA<br/>DE ARACAJU</p>
        </Stack>
    )
}


function Botoes({ })
{
    return (
        <Stack direction="horizontal" className="justify-content-end" gap={3}>
            <Link className="btn btn-primary fs-6 rounded-3" to="/">
                <Image src={headerHome} />
                Home
            </Link>

            <div className="btn btn-primary container rounded-3">
                <div className="row">
                    {/* <div className="col">
                        <Image src={headerAcessColors} onClick={SwitchColors} />
                    </div> */}
                    <div className="col">
                        <p className="fs-6 my-0" onClick={ShortenFont}>A-</p>
                    </div>
                    <div className="col">
                        <p className="fs-6 my-0" onClick={DefaultFont}>A</p>
                    </div>
                    <div className="col">
                        <p className="fs-6 my-0" onClick={EnlargeFont}>A+</p>
                    </div>
                </div>
                <div className="row">
                    <p className="fs-6 my-0">Acessibilidade</p>
                </div>
            </div>
        </Stack>
    )
}

export default function Header()
{
    return (
        <header>
            <Container className="bg-light text-dark my-2">
                <Row>
                    <Col>
                        <PrefeituraInfo />
                    </Col>
                    <Col className="d-flex justify-content-center">
                        <Botoes />
                    </Col>
                </Row>
            </Container>
        </header>
    )
}